import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CodeDisplayComponent } from './../../common-components/code-display/code-display.component';
import { Game } from './../../model/Game';
import { Result } from './../../model/Result';
import { CodeGeneratorService } from './../../services/code-generator.service';
import { GameService } from './../../services/game.service';
import { PlayerScoreService } from './../../services/player-score.service';

@Component({
  selector: 'app-code-game',
  templateUrl: './code-game.component.html',
  styleUrls: ['./code-game.component.less'],
  animations: [
    trigger('topIn', [
      transition('* => *', [
        query(':enter , .result', [

          style({ 'margin-top': "-4vh", opacity: 0 }),
          stagger(100,
            animate(100, style({ opacity: 1, 'margin-top': 0 }))
          )], { optional: true })


      ])
    ]),
    trigger('enterChace', [
      transition('* => *', [
        query(':enter', [

          style({ 'left': "-100vh", opacity: 0 }),
          stagger(100,
            animate(100, style({ opacity: 1, 'left': 0 }))
          )], { optional: true })


      ])
    ]),
  ]

})
export class CodeGameComponent implements OnInit, OnDestroy {
  private currentTime: number = 0;
  public currentTimeStr: string = "--:--";
  public progress: number = 100;
  public subs: Subscription[] = [];
  public noTries = false;

  @ViewChild("led")
  public led: ElementRef;

  public: number = 0;
  progressStr
  private timer;
  private _game: Game;
  @ViewChild("codeContainer", { static: true })
  private codeContainer: ElementRef;

  @ViewChild(CodeDisplayComponent, { static: true })
  private display: CodeDisplayComponent;

  @ViewChild("bar", { static: true })
  private bar: ElementRef;

  public get game(): Game {
    return this._game;
  }

  public set game(v: Game) {
    this._game = v;
  }

  public baseGame: Game;

  public tries: Result[] = [];
  public gameFinished: boolean = false;
  public isWinner: boolean = false;
  public current: number[] = [];
  public chaceOn: boolean = false;
  public score = new Score();
  private routerSub: Subscription;
  constructor(private codeGenerator: CodeGeneratorService,
    private playerScore: PlayerScoreService,
    private _location: Location,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private gameServide: GameService) {

    this.subs.push(this.route.queryParams.subscribe(p => {
      if (p["id"]) {
        const id: number = Number(p["id"]);

        this.gameServide.getDoor(id).then(r => {
          this.baseGame = r;
          this.newGame();
        })
      } else {
        this.newGame();
      }
    })
    )

  }

  public newNumber(): Promise<Game> {

    return this.codeGenerator.generateCode(this.baseGame).then(r => {
      this.game = r;
      return r;
    });
  }
  public comprar() {
    this.playerScore.addTries(100);
    this.noTries = false;
  }
  ngOnInit(): void {
    this.subs.push(this.playerScore.triesObs.subscribe(r => {
      if (r <= 0) {
        this.askPurchaseTries();
      }
    }));
  }
  public askPurchaseTries() {
    this.noTries = true;
  }

  public resign() {
    this.noTries = false;
    this.endGame(false);
  }
  ngOnDestroy(): void {
    if (this.score) this.score.reset();
    if (this.timer) clearInterval(this.timer);
    this.subs.forEach(s => s.unsubscribe());
  }

  public hasDuplicates(i: number) {
    return this.current.filter(e => e != undefined && this.current[i] == e).length > 1
  }
  public isCurrentValid() {
    let hasDuplicates = false;
    this.current.forEach((item, i) => {
      if (this.hasDuplicates(i)) {
        hasDuplicates = true;
      }
    })
    return this.current.filter(num => num >= 0).length == this.game.lock.digits && !hasDuplicates;
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.codeContainer) return;
    if (this.codeContainer.nativeElement.contains(event.target)) {
      this.display.showKeyboard();
    } else {
      this.display.hideKeyboard();
    }
  }
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) { 
    if (event.key === "Enter") {
      this.checkCode();
    } 
  }
  public checkCode() {
    if (this.isCurrentValid()) {
      this.renderer.addClass(this.led.nativeElement, "on");
      setTimeout(() => {
        this.renderer.removeClass(this.led.nativeElement, "on");
      }, 1000);
      let r = this.game.code.checkNumber(this.current);
      this.tries = [r].concat(this.tries);
      this.playerScore.addTries(-1);

      this.display.reset();
      if (this.tries.length == this.game.tries && !this.chaceOn) {
        this.startChace();
      }
      if (r.ok == this.game.lock.digits) {
        this.endGame(true);
      } else {

      }
    }


  }

  public newGame() {
    this.gameFinished = false;
    this.score.reset();

    this.newNumber().then(r => {
      console.log(r);
      this.current = [];
      this.tries = [];
      this.chaceOn = false;
      this.isWinner = false;
      this.currentTime = 9999999;
      if (this.timer) clearInterval(this.timer);
      this.currentTime = this.game.time;

    });
  }

  public startChace() {
    this.chaceOn = true;
    this.timer = setInterval(() => {
      this.currentTime -= 500;
      var minutes = Math.floor(this.currentTime / 60000);
      let minutesStr = (Math.round(minutes) < 10) ? '0' + minutes : minutes + "";
      var seconds = (this.currentTime % 60000) / 1000;
      var secondsStr = Math.round(seconds) < 10 ? "0" + seconds.toFixed(0) : seconds.toFixed(0);
      this.currentTimeStr = minutesStr + ":" + secondsStr;
      this.progress = Math.floor((this.currentTime / (this.game.time ? this.game.time : 1)) * 100);
      this.progressStr = this.progress + "%";
      if (this.currentTime < 15000) {
        this.renderer.removeClass(this.bar.nativeElement, "warning")
        this.renderer.addClass(this.bar.nativeElement, "danger");

      } else if (this.currentTime < 60000) {
        this.renderer.addClass(this.bar.nativeElement, "warning")
      }
      if (this.currentTime <= 0) {
        clearInterval(this.timer);
        this.endGame(false);
        return;
      }
    }, 500);
  }
  public changeState(digit: any) {
    console.log(digit);
  }
  public back() {
    this._location.back();
  }
  private endGame(winner: boolean) {
    this.score.reset();
    this.gameFinished = true;
    if (this.bar) {
      this.renderer.removeClass(this.bar.nativeElement, "danger");
    }

    this.isWinner = winner;
    clearInterval(this.timer);

    if (winner) {
      this.score.difficulty = this.game.lock.digits * 1000;
      /*this.score.time = this.currentTime / 100;
      this.score.tries = (this.game.lock.lock.tries - this.tries.length) * 100;*/
      this.playerScore.addScore(this.score.total);
      this.score.animate();
    }

  }

  public escape() {
    this.endGame(false);
  }

  public hideKeypad() {
    if (this.display) {
      this.display.hideKeyboard();
    }
  }
}

export class Score {


  private _time: number;
  private _difficulty: number;
  private _tries: number;

  public stepTime: number;
  public stepDifficulty: number;
  public stepTries: number;
  public get tries(): number {
    return this._tries;
  }
  public set tries(v: number) {
    this._tries = v;
    this.stepTries = 0;
  }

  public get difficulty(): number {
    return this._difficulty;
  }
  public set difficulty(v: number) {
    this._difficulty = v;
    this.stepDifficulty = 0;
  }

  public get time(): number {
    return this._time;
  }
  public set time(v: number) {
    this._time = v;
    this.stepTime = 0;
  }

  private interval;
  public reset() {
    clearInterval(this.interval);
    this.difficulty = 0;
    this.time = 0;
    this.tries = 0;
  }

  public animate() {
    const part = 150;

    this.interval = setInterval((r) => {
      if (this.stepTime + part <= this.time) {
        this.stepTime += part;
      } else {
        this.stepTime = this.time;
      }
      if (this.stepDifficulty + part <= this.difficulty) {
        this.stepDifficulty += part;
      } else {
        this.stepDifficulty = this.difficulty;
      }
      if (this.stepTries + part <= this.tries) {
        this.stepTries += part;
      } else {
        this.stepTries = this.tries;
      }
      if (this.stepTotal == this.total) {
        clearInterval(this.interval);
      }
    }, 100)

  }

  public get stepTotal() {
    return this.stepTime + this.stepTries + this.stepDifficulty;
  }
  public get total() {
    return this.time + this.difficulty + this.tries;
  }

}